export default "__VITE_ASSET__CTSjJV9v__"